var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.masterAdmin === true && !_vm.$store.state.switch_admin_username
            ? _c("masteradmin-sidebar-menu")
            : _vm._e(),
          _vm._v(" "),
          _vm.admin === true || _vm.$store.state.switch_admin_username
            ? _c("admin-sidebar-menu")
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c(
              "div",
              { staticClass: "container-wrapper center" },
              [
                _c(
                  "div",
                  [
                    _c("h3", { staticClass: "d-inline heading" }, [
                      _vm._v(_vm._s(_vm.pageHeading))
                    ]),
                    _vm._v(" "),
                    _c("flash-message", {
                      attrs: { autoHide: "", variant: "success" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "heading-seperator" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 p-0" }, [
                      _vm.successMsg
                        ? _c(
                            "div",
                            { staticClass: "alert alert-success mt-2" },
                            [_vm._v(_vm._s(_vm.successMsg))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "search-padd" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 override-padding mt-2" },
                          [
                            _c(
                              "div",
                              {
                                class:
                                  "edit_form_manager_heading " +
                                  _vm.getFormHeadingOne(
                                    _vm.form_fields_obj.forms.public_flag
                                  ) +
                                  " text-align-left"
                              },
                              [_vm._v("Form Name")]
                            ),
                            _vm._v(" "),
                            _vm.form_fields_obj.forms.public_flag
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "edit_form_manager_heading form_heading_2 text-align-left"
                                  },
                                  [_vm._v("Affiliate")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "edit_form_manager_heading form_heading_3 text-align-left"
                              },
                              [_vm._v("User Type(s)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "edit_form_manager_heading form_heading_4 text-align-left"
                              },
                              [_vm._v("Status")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "edit_form_manager_heading form_heading_5 text-align-center"
                              },
                              [_vm._v(" ")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { clear: "both" } }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "admin_details",
                            attrs: { id: "mentee_details_more" }
                          },
                          [
                            _c(
                              "div",
                              {
                                class:
                                  "edit_form_field_lists " +
                                  _vm.getFormHeadingOne(
                                    _vm.form_fields_obj.forms.public_flag
                                  ) +
                                  " text-align-left"
                              },
                              [
                                _c("div", { staticClass: "search-padd" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.form_fields_obj.forms.form_name,
                                        expression:
                                          "form_fields_obj.forms.form_name"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass:
                                      "col-12 col-sm-12 ma-input-field",
                                    attrs: {
                                      name: "form_name",
                                      placeholder: "Enter Form Name",
                                      maxlength: "255"
                                    },
                                    domProps: {
                                      value: _vm.form_fields_obj.forms.form_name
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form_fields_obj.forms,
                                          "form_name",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule(
                                    "form_name",
                                    "required"
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("Form name is required")]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.form_fields_obj.forms.public_flag
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "edit_form_field_lists form_heading_2 text-align-left"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "search-padd",
                                        attrs: { id: "edit-form-affiliate" }
                                      },
                                      [
                                        _c("multiselect", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "input_field",
                                          attrs: {
                                            options: _vm.affiliate_options,
                                            "track-by": "name",
                                            label: "name",
                                            placeholder: "Select an Affiliate",
                                            multiple: true,
                                            "close-on-select": false,
                                            "show-labels": false,
                                            name: "affiliate",
                                            id: "affiliate"
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "selection",
                                              fn: function(ref) {
                                                var values = ref.values
                                                var search = ref.search
                                                var isOpen = ref.isOpen
                                                return [
                                                  values.length && !isOpen
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "multiselect__single"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              values.length
                                                            ) + " selected"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ]),
                                          model: {
                                            value:
                                              _vm.form_fields_obj.forms
                                                .affiliate_selected,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form_fields_obj.forms,
                                                "affiliate_selected",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form_fields_obj.forms.affiliate_selected"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.verrors.firstByRule(
                                      "affiliate",
                                      "required"
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "margin-bottom-5 validate-warning-msg"
                                          },
                                          [_vm._v("Affilates is required")]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "edit_form_field_lists form_heading_3 text-align-left"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "search-padd" },
                                  _vm._l(_vm.roles_options, function(
                                    userType,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "mr-2 float-left"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.form_fields_obj.forms
                                                  .usertypes_selected,
                                              expression:
                                                "form_fields_obj.forms.usertypes_selected"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate"
                                            }
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            id: "usertype_" + index,
                                            name: "usertype",
                                            "data-vv-rules": "required",
                                            "data-vv-as": "User Type"
                                          },
                                          domProps: {
                                            value: userType.value,
                                            checked: Array.isArray(
                                              _vm.form_fields_obj.forms
                                                .usertypes_selected
                                            )
                                              ? _vm._i(
                                                  _vm.form_fields_obj.forms
                                                    .usertypes_selected,
                                                  userType.value
                                                ) > -1
                                              : _vm.form_fields_obj.forms
                                                  .usertypes_selected
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a =
                                                  _vm.form_fields_obj.forms
                                                    .usertypes_selected,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = userType.value,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.form_fields_obj.forms,
                                                      "usertypes_selected",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.form_fields_obj.forms,
                                                      "usertypes_selected",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.form_fields_obj.forms,
                                                  "usertypes_selected",
                                                  $$c
                                                )
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            attrs: { for: "usertype_" + index }
                                          },
                                          [_vm._v(_vm._s(userType.name))]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.verrors.firstByRule("usertype", "required")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "margin-bottom-5 mt-3 validate-warning-msg float-left"
                                      },
                                      [_vm._v("User Type is required")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "edit_form_field_lists form_heading_4 text-align-left"
                              },
                              [
                                _c("div", { staticClass: "search-padd" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.form_fields_obj.forms.status,
                                          expression:
                                            "form_fields_obj.forms.status"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      staticClass:
                                        "col-12 col-sm-12 ma-input-field",
                                      attrs: { name: "status" },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.form_fields_obj.forms,
                                            "status",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    _vm._l(_vm.statusOptions, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: item.value }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _vm.verrors.firstByRule("status", "required")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [_vm._v("Status is required")]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "edit_form_field_lists form_heading_5 text-align-left"
                              },
                              [
                                _c("div", { staticClass: "search-padd" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-red float-right",
                                      attrs: {
                                        disabled: _vm.isSubmit,
                                        type: "button"
                                      },
                                      on: { click: _vm.onSubmit }
                                    },
                                    [
                                      !_vm.isSubmit
                                        ? _c("b", [_vm._v("Save")])
                                        : _c("b", [_vm._v("Loading...")])
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { clear: "both" } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 p-0" }, [
                      _c("div", { staticClass: "d-flex bd-highlight mb-3" }, [
                        _c("div", { staticClass: "mr-auto p-2 bd-highlight" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "bd-highlight" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-red float-right",
                              on: {
                                click: function($event) {
                                  _vm.isPreloadedAddFieldsModalVisible = true
                                }
                              }
                            },
                            [_vm._m(0)]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ml-2 bd-highlight" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-red float-right",
                              on: {
                                click: function($event) {
                                  return _vm.addCustomFields("custom_field")
                                }
                              }
                            },
                            [_vm._m(1)]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.addCustomFieldsShow
                      ? _c("div", { staticClass: "form_field_list" }, [
                          _c(
                            "ul",
                            {
                              directives: [
                                {
                                  name: "sortable",
                                  rawName: "v-sortable",
                                  value: {
                                    onEnd: _vm.reorderFormField,
                                    handle: ".handle1"
                                  },
                                  expression:
                                    "{onEnd: reorderFormField, handle: '.handle1'}"
                                }
                              ],
                              staticClass:
                                "counter_field-list list-group col-lg-12 override-padding margin-bottom-10"
                            },
                            _vm._l(_vm.form_fields_obj.fields_lists, function(
                              fieldList,
                              fieldIndex
                            ) {
                              return _c(
                                "li",
                                {
                                  key: fieldList.sortid,
                                  staticClass:
                                    "list-group-item input-height-25 mb-2"
                                },
                                [
                                  _c("div", { staticClass: "field_item" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-9 col-12 float-left"
                                      },
                                      [
                                        fieldList.edit
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "float-left col-lg-11 col-10 override-padding"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: fieldList.name,
                                                      expression:
                                                        "fieldList.name"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required",
                                                      expression: "'required'"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "col-lg-10 input-height-20",
                                                  attrs: {
                                                    name:
                                                      "field_name[" +
                                                      fieldIndex +
                                                      "]",
                                                    placeholder:
                                                      "Enter Field Name",
                                                    maxlength: "75"
                                                  },
                                                  domProps: {
                                                    value: fieldList.name
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        fieldList,
                                                        "name",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-red btn-md input-height-15",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.updateFormsAction(
                                                          fieldList
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_c("b", [_vm._v("Save")])]
                                                ),
                                                _vm._v(" "),
                                                _vm.verrors.firstByRule(
                                                  "field_name[" +
                                                    fieldIndex +
                                                    "]",
                                                  "required"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "margin-bottom-5 validate-warning-msg"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Field name is required"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "handle1 float-left col-lg-11 col-10 override-padding",
                                                staticStyle: {
                                                  "padding-top": "2px"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-arrows padding-right-5",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass:
                                                    "counter_field-list__counter",
                                                  attrs: {
                                                    "data-v-31a1a9be": ""
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                                          " +
                                                    _vm._s(
                                                      fieldList.name
                                                        ? fieldList.name
                                                        : "Enter Field Name "
                                                    )
                                                ),
                                                fieldList.isNameEdit
                                                  ? _c("i", {
                                                      staticClass:
                                                        "cursor-pointer fa fa-pencil-square-o ml-2",
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          fieldList.edit = true
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 col-12 float-right override-padding text-align-right"
                                      },
                                      [
                                        _vm.form_fields_obj.forms.status ==
                                          "DRAFT" || fieldList.update == false
                                          ? _c("i", {
                                              staticClass:
                                                "cursor-pointer fa fa-times",
                                              staticStyle: {
                                                "padding-left": "10px"
                                              },
                                              attrs: { "aria-hidden": "true" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteFormFieldConfirm(
                                                    fieldIndex
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: { clear: "both" }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "margin-left-35" }, [
                                    _c("div", { staticClass: "row m-0" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-9 col-12 field_item_group"
                                        },
                                        [
                                          _c("b-form-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass:
                                              "col-lg-9 col-sm-9 col-8 input-height-15",
                                            staticStyle: { height: "30px" },
                                            attrs: {
                                              name:
                                                "field_type[" +
                                                fieldIndex +
                                                "]",
                                              options: _vm.custom_fields_types,
                                              disabled: fieldList.is_custom
                                                ? false
                                                : true
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.updateFieldType(
                                                  fieldList
                                                )
                                              }
                                            },
                                            model: {
                                              value: fieldList.field_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  fieldList,
                                                  "field_type",
                                                  $$v
                                                )
                                              },
                                              expression: "fieldList.field_type"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.verrors.firstByRule(
                                            "field_type[" + fieldIndex + "]",
                                            "required"
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "margin-bottom-5 validate-warning-msg"
                                                },
                                                [
                                                  _vm._v(
                                                    "Field type is required"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-3 col-12 field_item_group default_box"
                                        },
                                        [
                                          _c("label", [_vm._v("Default:")]),
                                          _vm._v(" "),
                                          _vm._l(_vm.requiredOptions, function(
                                            option,
                                            rindex
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: rindex,
                                                staticClass:
                                                  "form-check form-check-inline"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        fieldList.is_default,
                                                      expression:
                                                        "fieldList.is_default"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-check-input",
                                                  attrs: {
                                                    type: "radio",
                                                    id: "default_" + fieldIndex,
                                                    name:
                                                      "default_[" +
                                                      fieldIndex +
                                                      "]"
                                                  },
                                                  domProps: {
                                                    value: option.value,
                                                    checked: _vm._q(
                                                      fieldList.is_default,
                                                      option.value
                                                    )
                                                  },
                                                  on: {
                                                    change: [
                                                      function($event) {
                                                        return _vm.$set(
                                                          fieldList,
                                                          "is_default",
                                                          option.value
                                                        )
                                                      },
                                                      function($event) {
                                                        return _vm.updateFieldIsDefault(
                                                          fieldList
                                                        )
                                                      }
                                                    ]
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "form-check-label",
                                                    attrs: {
                                                      for:
                                                        "default_" + fieldIndex
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(option.text))]
                                                )
                                              ]
                                            )
                                          }),
                                          _vm._v(" "),
                                          _vm.verrors.firstByRule(
                                            "default_[" + fieldIndex + "]",
                                            "required"
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "margin-bottom-5 validate-warning-msg"
                                                },
                                                [_vm._v("Default is required")]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]),
                                    _vm._v(" "),
                                    fieldList.field_type != "" &&
                                    fieldList.field_type != "text"
                                      ? _c(
                                          "div",
                                          { staticClass: "field_item" },
                                          [
                                            _c(
                                              "ul",
                                              {
                                                directives: [
                                                  {
                                                    name: "sortable",
                                                    rawName: "v-sortable",
                                                    value: {
                                                      onEnd:
                                                        _vm.reorderFormFieldValues,
                                                      handle: ".handle2",
                                                      group: {
                                                        name:
                                                          "field-" + fieldIndex,
                                                        put: _vm.createFieldOptionValuesGroupArray()
                                                      }
                                                    },
                                                    expression:
                                                      "{onEnd: reorderFormFieldValues, handle: '.handle2', group: { name: 'field-' + fieldIndex, put: createFieldOptionValuesGroupArray() }}"
                                                  }
                                                ],
                                                staticClass:
                                                  "counter_field_option-list list-group col-lg-12 override-padding margin-bottom-10 field_values_ul",
                                                attrs: { "data-id": fieldIndex }
                                              },
                                              _vm._l(
                                                fieldList.field_values,
                                                function(fieldVal, fIndex) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: fieldVal.sortid,
                                                      staticClass:
                                                        "list-group-item input-height-25 mb-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "handle2 float-left col-md-8 col-12 override-padding"
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-arrows padding-right-5",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass:
                                                              "counter_field_option-list__counter"
                                                          }),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  fieldVal.optionValue,
                                                                expression:
                                                                  "fieldVal.optionValue"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "col-6 input-height-20",
                                                            attrs: {
                                                              placeholder:
                                                                "Enter Field Answer",
                                                              maxlength: "75"
                                                            },
                                                            domProps: {
                                                              value:
                                                                fieldVal.optionValue
                                                            },
                                                            on: {
                                                              keyup: function(
                                                                $event
                                                              ) {
                                                                return _vm.updateFieldOptionValue(
                                                                  fieldVal,
                                                                  fieldIndex
                                                                )
                                                              },
                                                              blur: function(
                                                                $event
                                                              ) {
                                                                return _vm.updateFieldOptionValue(
                                                                  fieldVal,
                                                                  fieldIndex
                                                                )
                                                              },
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  fieldVal,
                                                                  "optionValue",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 col-12 float-right override-padding text-align-right"
                                                        },
                                                        [
                                                          fieldList.is_custom &&
                                                          (_vm.form_fields_obj
                                                            .forms.status ==
                                                            "DRAFT" ||
                                                            fieldList.update ==
                                                              false)
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "cursor-pointer fa fa-times",
                                                                staticStyle: {
                                                                  "padding-left":
                                                                    "10px"
                                                                },
                                                                attrs: {
                                                                  "aria-hidden":
                                                                    "true"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.deleteFieldAnswerConfirm(
                                                                      fIndex,
                                                                      fieldIndex
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticStyle: {
                                                          clear: "both"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm._v(" "),
                                            fieldList.field_type != "text"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-content-end mt-2 mb-2"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-red float-right",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.addFieldAnswersAction(
                                                              fieldIndex,
                                                              fieldList
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v("Add Fields")
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _vm.form_fields_obj.fields_lists.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-end mt-2 mb-2"
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-red float-right",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.isSubmit
                                      },
                                      on: { click: _vm.onSubmit }
                                    },
                                    [
                                      !_vm.isSubmit
                                        ? _c("b", [_vm._v("Save")])
                                        : _c("b", [_vm._v("Loading...")])
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { clear: "both" } }),
                _vm._v(" "),
                _c(
                  "PreloadedAddFieldsModal",
                  {
                    attrs: {
                      isModalVisible: _vm.isPreloadedAddFieldsModalVisible
                    },
                    on: {
                      close: function($event) {
                        return _vm.closePreloadedAddFieldsModal()
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v(
                            "\n                  Loading...\n                  "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_c("h3", [_vm._v("Add Fields")])]
                    ),
                    _vm._v(" "),
                    _vm.isPreloadedAddFieldsModalVisible === true
                      ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                          _c("p", [_vm._v("Select Fields to add:")]),
                          _vm._v(" "),
                          _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.addPreloadedFields()
                                }
                              }
                            },
                            [
                              _vm._l(_vm.preloaded_fields_options, function(
                                field,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "row" },
                                  [
                                    field.id
                                      ? _c(
                                          "div",
                                          { staticClass: "col-12 ml-2" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.preloaded_fields_selected,
                                                  expression:
                                                    "preloaded_fields_selected"
                                                }
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                id: "field_" + index,
                                                name: "preloaded_fields",
                                                disabled: _vm.isPreloadedFieldAlreadyAdded(
                                                  field.weight
                                                )
                                              },
                                              domProps: {
                                                value: field.weight,
                                                checked: Array.isArray(
                                                  _vm.preloaded_fields_selected
                                                )
                                                  ? _vm._i(
                                                      _vm.preloaded_fields_selected,
                                                      field.weight
                                                    ) > -1
                                                  : _vm.preloaded_fields_selected
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a =
                                                      _vm.preloaded_fields_selected,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = field.weight,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.preloaded_fields_selected = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.preloaded_fields_selected = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.preloaded_fields_selected = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                attrs: { for: "field_" + index }
                                              },
                                              [_vm._v(_vm._s(field.name))]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.preloaded_fields_errors
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Select Fields to add is required")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "margin-bottom-10",
                                staticStyle: { clear: "both" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 override-padding text-align-right"
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-sm fmAddBtn",
                                      attrs: { type: "submit" }
                                    },
                                    [_c("b", [_vm._v("Add Field(s)")])]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ValidationModal",
                  {
                    attrs: { isModalVisible: _vm.isValidationModalVisible },
                    on: {
                      close: function($event) {
                        _vm.isValidationModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v("Loading...")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_vm._v(_vm._s(_vm.validationMessage))]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "DeleteModal",
                  {
                    attrs: {
                      isModalVisible: _vm.isDeleteModalVisible,
                      id: _vm.id,
                      parent_id: _vm.parent_id
                    },
                    on: {
                      close: function($event) {
                        _vm.isDeleteModalVisible = false
                      }
                    }
                  },
                  [
                    _vm.loading
                      ? _c("span", { staticClass: "pull-right text-danger" }, [
                          _vm._v(
                            "\n                      Loading...\n                  "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sub-heading",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [_vm._v(_vm._s(_vm.deleteMessage))]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-3 override-padding",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "left col-12 btn btn-red",
                            on: {
                              click: function($event) {
                                _vm.isDeleteModalVisible = false
                                _vm.deleteAction()
                              }
                            }
                          },
                          [_vm._v("Confirm")]
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c("i", {
        staticClass: "fa fa-plus spacer-icon",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v("Field")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c("i", {
        staticClass: "fa fa-plus spacer-icon",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v("Custom Field")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ca4493a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ca4493a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/add_form_custom_fields.vue
// module id = null
// module chunks = 